import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useInView } from 'react-intersection-observer';

const ImageUtil = ({ picPath, alt, className, showAppearAnimation = false }) => {
    const debounceTimeoutRef = useRef(0);
    const placeHolderUrl = 'https://lplauctionimg.tor1.cdn.digitaloceanspaces.com/DisplayImg/CompanyLogo/logPlaceholder.jpg';
    const apiDjangoUrl = process.env.REACT_APP_DJANGO_URL;
    const CACHE_EXPIRATION_TIME = 5 * 60 * 1000;

    // State to track the image URL and loading status
    const [imageUrl, setImageUrl] = useState('');
    const [isLoaded, setIsLoaded] = useState(false); // For handling the fade-in effect
    const { ref, inView } = useInView({
        triggerOnce: true, // Only fetch the image once it's in view
        threshold: 0.1, // Image should be 10% visible before loading
    });

    useEffect(() => {
        const fetchProductPictures = async (picPath) => {
            if (!picPath) return '';

            // Check localStorage for cached picture
            const cachedData = localStorage.getItem(picPath);
            if (cachedData) {
                const { imageUrl, timestamp } = JSON.parse(cachedData);
                const now = new Date().getTime();

                // Check if the cache has expired
                if (now - timestamp < CACHE_EXPIRATION_TIME) {
                    return imageUrl;
                } else {
                    // Remove expired cache
                    localStorage.removeItem(picPath);
                }
            }

            try {
                const folderPath = picPath.includes("/Public/ProductPicture")
                    ? `compressed${picPath.slice(picPath.indexOf("/Public/ProductPicture") + 22)}`
                    : `compressed/${picPath}`;
                const response = await axios.get(`${apiDjangoUrl}/api/first-image/${encodeURIComponent(folderPath)}/`);
                const fetchedImageUrl = response.data.image_url;
                console.log("Fetched image URL:", fetchedImageUrl);

                // Store the fetched picture in localStorage with a timestamp
                const cacheData = {
                    imageUrl: fetchedImageUrl,
                    timestamp: new Date().getTime(),
                };
                localStorage.setItem(picPath, JSON.stringify(cacheData));
                return fetchedImageUrl;
            } catch (error) {
                console.error("Error fetching picture:", error);
                return placeHolderUrl;
            }
        };

        if (inView && picPath) {
            fetchProductPictures(picPath).then((url) => {
                if (url) {
                    setImageUrl(url);
                    setIsLoaded(false); // Reset loading state before image is loaded
                }
            });
        }
    }, [inView, picPath]);

    return (
        <div
            ref={ref}
            className={`util-image-container ${className}`}
            style={{ backgroundColor: '#ffffff', width: '100%', height: '100%' }}
        >
            {imageUrl ? (
                <img
                    src={imageUrl}
                    alt={alt}
                    className={`util-image-content ${showAppearAnimation && (inView ? 'inital-picture-animation product-link' : 'show-opacity')}`}
                    style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
                    onLoad={() => setIsLoaded(true)} // Set the image as loaded once it finishes loading
                />
            ) : null}
        </div>
    );
};

export default ImageUtil;
